import React from "react";
import Image from "next/image";
import styles from "./SocialLinks.module.css";

interface SocialLink {
  name: string;
  href: string;
  icon: string;
  alt: string;
  width?: number;
  height?: number;
}

interface SocialLinksProps {
  links: SocialLink[];
  className?: string;
}

export default function SocialLinks({ links, className = "" }: SocialLinksProps) {
  return (
    <div className={`${styles['social-links']} ${className}`}>
      {links.map((link, index) => (
        <a
          key={index}
          href={link.href}
          className={styles['social-link']}
          aria-label={`Theo dõi chúng tôi trên ${link.name}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Image
            src={link.icon}
            alt={link.alt}
            className={styles['social-icon']}
            width={link.width || 80}
            height={link.height || 80}
          />
        </a>
      ))}
    </div>
  );
}
